<script>
    import {api_host, doToast} from "../stores.js";
    // import {curried_gv} from "../globals.js";

    import {querystring} from 'svelte-spa-router'
    import { onDestroy, onMount } from 'svelte';
    import Header from "./header.svelte";
    import breakpoints from "../utils/breakpoints";
    import {link, location, push, pop, replace} from 'svelte-spa-router';
    import IFTAInput from "../utils/iftainput.svelte";

    import validate from 'validate.js';
    // import { toast } from '@zerodevx/svelte-toast'

    // setup
    const bp = breakpoints();

    let content_title = "Editing Gift Card";
    let gcid = "";
    let is_busy = false;

    const timeframe_to_days_map = {
        "1 week": 7,
        "2 weeks": 7 * 2,
        "3 weeks": 7 * 3,
        "1 month": 7 * 4,
        "3 months": 7 * 4 * 3,
        "6 months": 7 * 4 * 6,
    };

    function timeframeChange(new_time_frame, start_date_object_index, end_date_object_index){
        const start_value = fields[start_date_object_index]["value"];
        const day_range = timeframe_to_days_map[new_time_frame];

        var parts =start_value.split('/');
        var new_end_date = new Date(parseInt(parts[2]) + 2000, parts[0] - 1, parts[1]); 

        new_end_date.setDate(new_end_date.getDate() + day_range);

        fields[end_date_object_index]["value"] = format_date_to_default_string(new_end_date);

        // console.log(new_end_date.toDateString());

    }

    // lifecycle items
    onMount(async () => {
        // console.log(`querystrning is ${$querystring}`)
        const params = new URLSearchParams($querystring)

        if (params.has("gcid")) {
            gcid = params.get("gcid");
        }
        // console.log( Array.from(params.keys()) );


    });

    let constraints = {
        "price": {
            presence: {allowEmpty: false},
            numericality: true,
        },
        "original_price": {
            presence: {allowEmpty: false},
            numericality: true,
        },
        "next_service_price": {
            presence: {allowEmpty: false},
            numericality: true,
        },
        "contractor_margin": {
            presence: {allowEmpty: false},
            numericality: true,
        },
        "contractor_price": {
            presence: {allowEmpty: false},
            numericality: true,
        },
        // "contractor_name": {
        //     presence: {allowEmpty: false},
        // },
        // "additional_comments": {
        //     presence: {allowEmpty: false},
        // },
        // "additional_comments": {},
    };
    // var constraints = {
    // creditCardNumber: {
    //     presence: true,
    //     format: {
    //     pattern: /^(34|37|4|5[1-5]).*$/,
    //     message: function(value, attribute, validatorOptions, attributes, globalOptions) {
    //         return validate.format("^%{num} is not a valid credit card number", {
    //         num: value
    //         });
    //     }
    //     },
    //     length: function(value, attributes, attributeName, options, constraints) {
    //     if (value) {
    //         // Amex
    //         if ((/^(34|37).*$/).test(value)) return {is: 15};
    //         // Visa, Mastercard
    //         if ((/^(4|5[1-5]).*$/).test(value)) return {is: 16};
    //     }
    //     // Unknown card, don't validate length
    //     return false;
    //     }
    // },
    // creditCardZip: function(value, attributes, attributeName, options, constraints) {
    //     if (!(/^(34|37).*$/).test(attributes.creditCardNumber)) return null;
    //     return {
    //     presence: {message: "is required when using AMEX"},
    //     length: {is: 5}
    //     };
    // }
    // };    
    // function curry(f) {
    //     return function(a) {
    //         return function(b) {
    //         return f(a, b);
    //         };
    //     };
    // }

    // function generic_validation(field_name, value) {
    //     let validator = {};
    //     validator[field_name] = value;
    //     let vres = validate(validator, constraints);
    //     // console.log(vres);
    //     if(vres !== undefined && field_name in vres) {
    //         return [false, vres[field_name][0], undefined];
    //     } else {
    //         return [true, "", undefined];
    //     }
    // }

    // let curried_gv = curry(generic_validation);

    let fields = [
        {
            "index": 0,
            "group": "participants",
            "type": "text",
            "label": "Giver",
            "value": "admin@houseofyards.com",
            "placeholder": "eg. giver@gmail.com" 
        },
        {
            "index": 1,
            "group": "participants",
            "type": "text",
            "label": "Recipient",
            "value": "admin@houseofyards.com",
            "placeholder": "eg. recipient@gmail.com",
        },
        {
            "index": 2,
            "group": "cardrow2",
            "type": "select",
            "label": "Is Gift?",
            "value": "Yes",
            "select_options": ["Yes", "No"],
        },
        {
            "index": 3,
            "group": "cardrow2",
            "type": "select",
            "label": "Type",
            "value": "Maximum Amount",
            "select_options": ["Maximum Amount", "Other"],
        },
        {
            "index": 4,
            "group": "cardrow2",
            "type": "text",
            "label": "Redemption Limit",
            "value": "0",
        },
        {
            "index": 5,
            "group": "cardrow2",
            "type": "text",
            "label": "Value",
            "value": "5.00",
            // "validation_function": (value) => $curried_gv("contractor_price"),
        },
        {
            "index": 6,
            "group": "cardrow3",
            "type": "date",
            "label": "Valid From",
            "value": '01/02/21',
            "change_function": (e) => {
                console.log(e);
            },
        },
        {
            "index": 7,
            "group": "cardrow3",
            "type": "select",
            "label": "Valid Timeframe",
            "value": "6 months",
            "select_options": ["1 week", "2 weeks", "3 weeks", "1 month", "3 months", "6 months"],
            "change_function": (e)=>{
                const time_frame = e.target.value;
                timeframeChange(time_frame, 6, 8);
            }
        },
        {
            "index": 8,
            "group": "cardrow3",
            "type": "text",
            "label": "Valid Until",
            "value": '07/01/21',
            "readonly": true,
        },
        {
            "index": 9,
            "group": "cardrow4",
            "type": "textarea",
            "label": "Additional Comments",
            "value": "",
            "placeholder": "... any additional comments for this gift card.",
        },

        // {
        //     "index": 0, 
        //     "type": "text", 
        //     "label": "Contractor Name", 
        //     "placeholder": "Jone C. Contractor", 
        //     "value": "",
        //     "validation_function": (value) => {
        //         console.log(`... testing 0: "${value}"`); 
        //         let vres = validate({"contractor_name": value}, constraints);
        //         if(vres !== undefined) {
        //             return [false, vres["contractor_name"][0], undefined];
        //         } else {
        //             return [true, "", undefined];
        //         }
        //     }
        // },
        // {
        //     "index": 1, 
        //     "type": "textarea", 
        //     "label": "Additional Comments", 
        //     "placeholder": "Some relevant comments", 
        //     "value": "", 
        //     "validation_function": (value) => {
        //         console.log(`... testing 1: "${value}"`); 
        //         let vres = validate({"additional_comments": value}, constraints);
        //         if(vres !== undefined) {
        //             return [false, vres["additional_comments"][0], undefined];
        //         } else {
        //             return [true, "", undefined];
        //         }
        //     }
        // },

    ];

    $: remaining_value = fields[5].value;

    let validateForm = () => {
        console.log("validating form");
        let is_valid = true;
        for(let i = 0; i < fields.length; i++) {
            // console.log(fields[i]);
            let tfv = fields[i].ext_funcs.validateForm();
            if(!tfv) {
                is_valid = false;
            }
        }
        
        return is_valid;
    };
    
    let updateJob = () => {
        if(validateForm()) {
            $doToast("Form is valid. Would be updating job here.", "info");
        }else{
            $doToast("Form failed validation.", "error");
        }
    };

</script>

<Header bind:title={content_title} bind:is_busy={is_busy} />

<div class="contentholder">

    <div class="section cardinfo">
        <div class="sectiontitle"><i class="fas fa-gift"></i> Gift Card Information</div>


        <div class="sectioninfo">
            <div class="column">

                <div class="infoitem">
                    <div class="infoitemtitle">Code:</div>
                    <div class="infoitemvalue">GIFT-DZZZNJGDSFEHVMT</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Redemptions:</div>
                    <div class="infoitemvalue">0</div>
                </div>
                <div class="infoitem">
                    <div class="infoitemtitle">Remaining Value:</div>
                    <div class="infoitemvalue">{remaining_value}</div>
                </div>
                
            </div>
        </div>
            
    </div>

    <div class="section carddetails">
        <div class="sectiontitle"><i class="fas fa-user-friends"></i> Participant Information</div>

        <div class="ff formrow">
            {#each fields.filter((e)=>e.group === "participants") as nf}
            <IFTAInput 
            type={(nf.type !== undefined) ? nf.type : ""} 
            label={(nf.label !== undefined) ? nf.label : ""} 
            placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
            helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
            select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
            readonly={nf.readonly}
            disabled={nf.disabled}
            bind:value={nf.value}
            bind:change_function={nf.change_function}
            bind:validation_function={nf.validation_function}
            bind:extFuncs={nf.ext_funcs} />
            {/each}
        </div>

        <div class="ff formrow">
            {#each fields.filter((e)=>e.group === "cardrow2") as nf}
            <IFTAInput 
            type={(nf.type !== undefined) ? nf.type : ""} 
            label={(nf.label !== undefined) ? nf.label : ""} 
            placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
            helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
            select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
            readonly={nf.readonly}
            disabled={nf.disabled}
            bind:value={nf.value}
            bind:change_function={nf.change_function}
            bind:validation_function={nf.validation_function}
            bind:extFuncs={nf.ext_funcs} />
            {/each}
        </div>

        <div class="ff formrow">
            {#each fields.filter((e)=>e.group === "cardrow3") as nf}
            <IFTAInput 
            type={(nf.type !== undefined) ? nf.type : ""} 
            label={(nf.label !== undefined) ? nf.label : ""} 
            placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
            helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
            select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
            readonly={nf.readonly}
            disabled={nf.disabled}
            bind:value={nf.value}
            bind:change_function={nf.change_function}
            bind:validation_function={nf.validation_function}
            bind:extFuncs={nf.ext_funcs} />
            {/each}
        </div>
        <div class="ff formrow">
            {#each fields.filter((e)=>e.group === "cardrow4") as nf}
            <IFTAInput 
            type={(nf.type !== undefined) ? nf.type : ""} 
            label={(nf.label !== undefined) ? nf.label : ""} 
            placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
            helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
            select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
            readonly={nf.readonly}
            disabled={nf.disabled}
            bind:value={nf.value}
            bind:change_function={nf.change_function}
            bind:validation_function={nf.validation_function}
            bind:extFuncs={nf.ext_funcs} />
            {/each}
        </div>


    </div>

    <div class="section updatebutton">
        <button class="save">Save Changes</button>
    </div>


</div>

<style>
    .ff {
        padding: 10px;
        width: 100%;
    }
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }
    .formrow {
        padding: 0px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }


    .section_old {
        width: 100%;
    }

    .section_old .sectiontitle_old {
        width: 100%;
        font-size: 20px;
        color: white;
        background-color: #1769aa;
        margin-bottom: 10px;
    }
    .section_old_old .sectiontitle_old i{
        width: 25px;
        display: none;

    }
    .sectioninfo {
        width: 100%;
    }
    .infoitem {
        display: flex;
        flex-direction: row;
    }
    .infoitem .infoitemtitle {
        width: 150px;
        font-weight: bold;
        text-align: right;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
    }
    .infoitem .infoitemvalue {
        text-align: left;
        margin-left: 10px;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
    }
    .column{
        display: flex;
        flex-direction: column;
    }

    .contentholder {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-template-rows: auto;
        grid-template-areas: "ci ci ci ci ci ci ci ci ci ci ci ci"
                             "cd cd cd cd cd cd cd cd cd cd cd cd"
                             "ub ub ub ub ub ub ub ub ub ub ub ub";
        gap: 20px;
    }
    .infoitem {
        width: 100%;
        display: flex;
        flex-direction: row;
    }
    .infoitem .infoitemtitle {
        width: 150px;
        font-weight: bold;
        text-align: right;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
    }
    .infoitem .infoitemvalue {
        text-align: left;
        margin-left: 10px;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
    }

    .sectioninfo {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .column{
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .cardinfo {
        grid-area: ci;
    }
    .carddetails {
        grid-area: cd;
    }
    .updatebutton {
        grid-area: ub;
        display: flex;
        flex-direction: row;
        justify-content: start;
    }
    .updatebutton .save {
        width: 200px;
        background-color: #357a38;
        color: white;
    }


    @media (max-device-width: 1024px), (max-width: 1023px) {
        .ff {
            padding: 10px;
            width: 100%;
        }
        .formrow {
            width: 100%;
            padding: 0px;
            display: flex;
            flex-direction: column;
        }

        .section_old_old {
            padding: 0px;
        }
        .contentholder {
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            grid-template-rows: auto;
            grid-template-areas: "ci"
                                 "cd"
                                 "ub";
            gap: 20px;

        }
        .cardinfo {
            grid-area: ci;
        }
        .carddetails {
            grid-area: cd;
        }
        .updatebutton {
            grid-area: ub;
            display: flex;
            flex-direction: column;
            padding: 0px;
        }
        .updatebutton .save {
            width: 100%;
            background-color: #357a38;
            color: white;
        }
        
    }

</style>